let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jXIn9"), load("6d83I")]).then(() => parcelRequire('2uezU'));